export interface SendChatVariables {
  query: string;
  conversationId?: string | null;
}

export enum ChatRoleEnum {
  ai = 'ai',
  human = 'human'
}
